// extracted by mini-css-extract-plugin
export var quillEditor = "_id-1";
export var variable = "_id-0";